module.exports = __webpack_public_path__ + "img/random-fail-student-gai.ac11a4d6.png";